<div id="button">
  <button
    type="button"
    class="btn"
    [disabled]="disabled"
    (click)="onClickButton($event)"
  >
    <ng-content></ng-content>
    <span *ngIf="icon" class="k-icon k-font-icon k-i-{{ icon }}"></span>
  </button>
</div>
